import React, { useState, useEffect } from 'react';
import Copyright from '../Copyright';
import { Box, Container, Grid } from '@mui/material';
import Typography from '@mui/material/Typography';
import httpRequest from '../HttpService';
import PageBanner from '../orderStatus/components/pageBanner';
import { Button} from '@mui/material';
import LogoutIcon from '@mui/icons-material/ArrowForward';
import { useUserContext} from "../lib/user_context";
import { useNavigate } from 'react-router-dom';


export default function Preferences(props)  {
    const navigate = useNavigate();
    const { sessionLoginUser,sessionPreference,sessionAccountAddress} = useUserContext();
    const [user,setUser] = useState(sessionLoginUser);
    const [address,setAddress] = useState(JSON.parse(sessionAccountAddress));
    const [preferences,setPreferences] = useState(sessionPreference);

    useEffect(() => {
        //{"dbID":884,"addressID":"2366670","companyName":"DirectIT Group","suite":"Bay 30","address":"333 28 St","quad":"NE","city":"Calgary","prov":"Alberta","country":"Canada","postal":"T2A7P4","zone":"","contact":null,"phone":null,"long":-113.993987,"lat":51.053217,"gpserror":false,"locationID":"886092","private":false,"custNo":null,"contactID":null,"cnt":10,"cnt2":21,"HasGPS":1,"RowNumber":null,"events":null,"addressExtID":null,"LastDate":"2024-03-06T09:39:35.597Z","contactName":null,"contactPhone":null}
        // console.log("Preferences", props.address);
        // console.log("sessionPreference",sessionPreference)
        // console.log("sessionLoginUser",sessionLoginUser)
        // console.log("sessionAccountAddress",sessionAccountAddress)
        setUser(sessionLoginUser);
        setAddress(JSON.parse(sessionAccountAddress));
        setPreferences(sessionPreference);
       
    },[sessionLoginUser,sessionPreference,sessionAccountAddress]);

       
   const handleLogout = (event) => {
        localStorage.clear();   
        window.location.href = "/"; 
    }

         
    return (
            <Container maxWidth="lg">
            <div style={{ padding: '40px 0 20px 0', textAlign: 'center' }}>
                <h1 style={{ color: 'black', margin: 0 }}>{address?.companyName}</h1>
                <h2 style={{ color: 'black', margin: 0 }}>{"#"+ user?.accountNumber}</h2>
            </div>
            <Box sx={{ display: 'flex', justifyContent: 'center', py: 3 }}>
                <Box sx={{ width: '100%', maxWidth: 720 }}>
                    <Grid container rowSpacing={5}>
                        <Grid item md={4} xs={5}>
                            <Typography style={{ fontWeight: 600 }}>Address</Typography>
                        </Grid>
                        <Grid item md={8} xs={7}>
                            <Typography style={{ fontWeight: 400 }}>{address?.suite ? `Suite ${address.suite}, ` : ''}{address?.address}{address?.quad ? ` ${address.quad}` : ''}</Typography>
                            <Typography style={{ fontWeight: 400 }}>{address?.city}{address?.prov ? `, ${address.prov}` : ''}{address?.postal ? `, ${address.postal}` : ''}{address?.country ? `, ${address.country}` : ''}</Typography>
                        </Grid>
                        <Grid item md={4} xs={5}>
                            <Typography style={{ fontWeight: 600 }}>Phone</Typography>
                        </Grid>
                        <Grid item md={8} xs={7}>
                            <Typography style={{ fontWeight: 400 }}>{address?.phone}</Typography>
                        </Grid>
                        <Grid item md={4} xs={5}>
                            <Typography style={{ fontWeight: 600 }}>Hours of Operation</Typography>
                        </Grid>
                        <Grid item md={8} xs={7}>
                            <Typography style={{ fontWeight: 400 }}>{preferences?.opentime}-{preferences?.closeTime}</Typography>
                        </Grid>
                        <Grid item xs={12} sx={{ display: 'flex', mt: 1 }}>
                            <Button
                                style={{ maxWidth: "300px", minWidth: "200px" }}
                                variant="contained"
                                color="primary"
                                startIcon={<LogoutIcon style={{ verticalAlign: 'middle', transform: 'scale(1.5)' }} />}
                                onClick={handleLogout}
                            >
                                Logout
                            </Button>
                        </Grid>
                    </Grid>
                </Box>
            </Box>
                {props.isEmbbed!== null && props.isEmbedded!=='yes' && <footer>
                    <Copyright/>
                </footer>}
             </Container>

        );
    }





